import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Pie Chart"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-pie-chart',
    templateUrl: './icon-pie-chart.component.html',
    styleUrls: ['./icon-pie-chart.component.scss'],
    standalone: false
})
export class IconPieChartComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
